export default "__VITE_ASSET__CoMDD8g___"